
























































































import {Component} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import OriginatorsFilter from "@/components/Originators/OriginatorsFilter.vue";
import {OriginatorItem} from "@/store/originators/types";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { notifyError, notifyDelete } from '@/utils/notify-helper';
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {OriginatorsFilter,LongTextWings,ScrollButton}})
export default class Originators extends BaseItemsPage<OriginatorItem> {
  @Getter("originators") originatorResponse: any;
  @Action("deleteOriginator") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = [
    'name',
    'transport',
    'status',
    'comment',
  ];
  logObject: ActionLog = {}

  getData(): any {
    return this.originatorResponse;
  }

  async onDeleteItem(item: OriginatorItem):Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Removal",
          actionStatus: 'success',
          objectType: "Originator",
          objectName: item.name,
          addititionalInfo: getTranslatedParams({transport: item.transport, id: item.id})
        }
        await this.actionDelete({ senderId: item.id })
        await this.actionLog(this.logObject);
      } catch (error) {
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    }
  }

  itemColor(status:string){
    switch (status) {
      case 'ACCEPTED':
        return 'background-chip-success'
      case 'DENIED':
        return 'background-chip-danger'
      default:
        return 'background-chip-warning'
    }
  }

}
